import { render, staticRenderFns } from "./NoticeboardList.vue?vue&type=template&id=4416c688&scoped=true"
import script from "./NoticeboardList.vue?vue&type=script&lang=js"
export * from "./NoticeboardList.vue?vue&type=script&lang=js"
import style0 from "./NoticeboardList.vue?vue&type=style&index=0&id=4416c688&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4416c688",
  null
  
)

export default component.exports